import { useEffect } from 'react';
import type { DirectFcfsCapacityPool } from 'src/apis/direct-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

export function useDirectFcfsCapacityPools(networkPointId?: string) {
  const capacityPoolsData = useAxios(
    (axios, baseConfig, networkPointId: string) =>
      axios.request<DirectFcfsCapacityPool[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.directFcfs}/network-points/${networkPointId}/capacity-pools`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!networkPointId) return;
    capacityPoolsData.execute(networkPointId);
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointId]);

  if (!networkPointId) return;

  return capacityPoolsData;
}

export type DirectFcfsCapacityPoolsRequest = ReturnType<
  typeof useDirectFcfsCapacityPools
>;
